import React from "react";
import { Language, Phrase, PhraseKey } from "./phrases";

export const LanguageContext = React.createContext({
  language: "",
  setLanguage: (_: Language) => {},
  ph: (_: PhraseKey): Phrase => "",
});
